import React from 'react'
import './Text.css'
import classNames from 'classnames'

const Text = ({ text = '', style = '', ...props }) => {
  let classes = classNames({
    'Text': true,
    'circular-book': true,
    'm-Small': style === 'small'
  })

  return (
    <div className={classes} {...props}>
      {text}
    </div>
  )
}

export default Text



// WEBPACK FOOTER //
// ./src/Components/Text/Text.js